import { render, staticRenderFns } from "./label.vue?vue&type=template&id=6f42d991"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f42d991')) {
      api.createRecord('6f42d991', component.options)
    } else {
      api.reload('6f42d991', component.options)
    }
    module.hot.accept("./label.vue?vue&type=template&id=6f42d991", function () {
      api.rerender('6f42d991', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/filter/v2/label.vue"
export default component.exports